import React from 'react';
import classNames from 'classnames';
import Image from '@/components/elements/image';

function IconText({ icon, text, height, width, appearance }) {
	return (
		<div className="flex items-start">
			{icon ? (
				<Image
					appearance={classNames('mt-1 mr-2', appearance)}
					src={icon.filename}
					alt={icon.alt || ''}
					height={height}
					width={width}
				/>
			) : null}
			{text ? <span className="whitespace-pre">{text}</span> : null}
		</div>
	);
}

export default IconText;
